module.exports = __webpack_public_path__ + "img/miracle.67de1cec.png";